import { computed } from 'vue'

import type { Deal } from '@backmarket/nuxt-layer-cms/products/algolia/types'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconArrowDownRightInCircleFilled } from '@ds/icons/IconArrowDownRightInCircleFilled'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'

import type { Granularity } from '../models/product'

import translations from './useProductCardDeal.translations'

export function useProductCardDeal(
  deal?: Deal,
  granularity?: Granularity,
  withDeal = true,
) {
  const i18n = useI18n()
  const experiments = useExperiments()

  const isFlashSalesEnabled = experiments['experiment.flashSales'] === 'enabled'

  const eligibleDeal = computed(() => {
    if (!withDeal || !deal || granularity !== 'backbox') return undefined

    if (isFlashSalesEnabled && deal.type === 'flash_sales') return deal

    if (deal.type === 'seller_flash_sales' && deal.percentage?.value)
      return deal

    return undefined
  })

  const dealTag = computed(() => {
    if (!eligibleDeal.value) return undefined

    if (eligibleDeal.value.type === 'flash_sales') {
      return {
        label: i18n(translations.flashSalesTag),
        icon: IconBoltFilled,
      }
    }

    if (
      eligibleDeal.value.type === 'seller_flash_sales' &&
      eligibleDeal.value.percentage
    ) {
      return {
        label: i18n(translations.sellerFlashSalesTag),
        icon: IconArrowDownRightInCircleFilled,
      }
    }

    return undefined
  })

  return {
    eligibleDeal,
    dealTag,
  }
}
